module.exports = "<p *ngIf=\"loading\">\n  Loading...\n</p>\n\n<a class=\"car\" *ngFor=\"let car of cars\" [routerLink]=\"['/cars', car.id]\">\n  <img class=\"image\" [src]=\"car.imageUrl\" />\n  <span class=\"title\">{{car.name}} - {{car.year}} {{car.make}} {{car.model}}</span>\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /Users/baylorrae/code/tutorials/graphcool/garage/src/app/car-list/car-list.component.html
// module id = ../../../../../src/app/car-list/car-list.component.html
// module chunks = main